import { render, staticRenderFns } from "./InventoryView.vue?vue&type=template&id=43e42dc4&scoped=true&"
import script from "./InventoryView.vue?vue&type=script&lang=js&"
export * from "./InventoryView.vue?vue&type=script&lang=js&"
import style0 from "./InventoryView.vue?vue&type=style&index=0&id=43e42dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e42dc4",
  null
  
)

component.options.__file = "InventoryView.vue"
export default component.exports